import useExamWorkspace from '@/data/hook/exam/useExamWorkspace';
import { ExamTabs } from '@/pages/course-line/ExamWorkspace';
import { ROUTES, withTab } from '@/utils/routes';

export default function useExamSettingsTo() {
  const { courseLineId, moduleId, slug, examId } = useExamWorkspace();

  if (!slug || !courseLineId || !moduleId || !examId) return undefined;

  return {
    to: withTab(
      ROUTES.ADMIN.COURSE_LINES.EXAM(courseLineId, moduleId, slug, examId),
      ExamTabs.SETTINGS,
    ),
  };
}
